import CameraBackground from "./CameraBackground";

// Export without redux connection
export default CameraBackground;
